import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { onMounted } from "vue";
import LoadingOverlay from "@/components/controls/LoadingOverlay.vue";
import { useI18n } from "vue-i18n";


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const { t } = useI18n();

onMounted(() => {
  document.addEventListener("swUpdated", (event) => {
    const registration = (event as CustomEvent).detail;

    // if (confirm(t("base.pwaUpdate"))) {
    refreshApp(registration);
    // }
  });
});

function refreshApp(registration: ServiceWorkerRegistration) {
  if (registration && registration.waiting) {
    registration.waiting.postMessage({ type: "SKIP_WAITING" });
    registration.waiting.addEventListener("statechange", (event) => {
      if ((event.target as ServiceWorker).state === "activated") {
        window.location.reload();
      }
    });
  }
}

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(LoadingOverlay),
    _createVNode(_component_router_view)
  ], 64))
}
}

})